import styled from 'styled-components';

export const OptionsMenuContainer = styled.div<{ $isHidden?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $isHidden: isHidden }) => (isHidden ? 0 : 1)};
  svg {
    cursor: pointer;
  }
`;

export const Menu = styled.div<{ $isHidden: boolean }>`
  min-width: 250px;
  position: absolute;
  left: calc(100% + 12px);
  top: 0;
  opacity: ${({ $isHidden: isHidden }) => (isHidden ? 0 : 1)};
  transform: ${({ $isHidden: isHidden }) => (isHidden ? 'translate(-10px, -10%)' : 'translate(0, -10%)')};
  transition:
    opacity 0.3s,
    transform 0.3s;
  pointer-events: ${({ $isHidden: isHidden }) => (isHidden ? 'none' : 'auto')};
  z-index: 99;
  background-color: ${({ theme }) => theme.colors.panelBackground};
  border-radius: ${({ theme }) => theme.borderRadius.normal};
  box-shadow: ${({ theme }) => theme.shadow.light};
  border: 1px solid ${({ theme }) => theme.colors.tableBorder};

  @media (max-width: 768px) {
    right: -12px;
    left: unset;
    top: 100%;
    transform: ${({ $isHidden: isHidden }) => (isHidden ? 'translate(0, 0)' : 'translate(0, 5px)')};
  }
`;

export const MenuItem = styled.div<{ $disabled?: boolean }>`
  width: 100%;
  padding: 8px 16px;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  &:hover {
    background-color: ${({ theme }) => theme.colors.insetPanelBackground};
  }
  &:first-child {
    border-top-left-radius: ${({ theme }) => theme.borderRadius.normal};
    border-top-right-radius: ${({ theme }) => theme.borderRadius.normal};
  }
  &:last-child {
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.normal};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.normal};
  }

  ${({ $disabled }) =>
    $disabled &&
    `
      opacity: 0.5;
      user-select: none;
      pointer-events: none;
    `}
`;
